<div class="sb-step sb-step-payment-method">
  <form class="sb-step__form" [formGroup]="formGroup">
    <!-- region Step container -->
    <div class="sb-step__form__content">
      <div class="sb-step__inner-container sb-step__inner-container--big extra-offers">
        <!-- SMART TOP UP -->
<!--        <div class="row" *ngIf="isSmartTopUpEnabled && !isSmartTopUpMandatory">-->
        <div class="row" *ngIf="hasDoublePO || (isSmartTopUpEnabled && !isSmartTopUpMandatory)">
          <!-- region Smart Top Up -->
          <div class="row smart-top-up-row">
<!--            <p class="stu-title">{{'ENTITY.OFFER-EXTRAS.ADD-SERVICES.TITLE' | translate}}</p>-->
            <div class="col-xs-12 offer-extras-form-group" formGroupName="offerExtras">
              <sb-display-input-checkbox-toggle (change)="checkValue(this.getFormControl(OFFER_EXTRAS, SMART_TOP_UP))"
                                         [control]="this.getFormControl(OFFER_EXTRAS, SMART_TOP_UP)"
                                         [title]="'ENTITY.OFFER-EXTRAS.SMART_TOP_UP.TITLE'"
                                         [subTitle]="'ENTITY.OFFER-EXTRAS.SMART_TOP_UP.DESCRIPTION'"
                                         [info]="'ENTITY.OFFER-EXTRAS.SMART_TOP_UP.INFO'"
                                         [statusKey]="'ENTITY.OFFER-EXTRAS.SMART_TOP_UP'"
                                         [hasDoublePO]="hasDoublePO"
                                         [deltagiga]="deltaGiga"
                                         [smartTopUpPromo]="smartTopUpPromo">
              </sb-display-input-checkbox-toggle>
            </div>
          </div>
          <!-- endregion -->
        </div>

        <!-- region Addons -->
        <div class="addons-box-container sb-form-block__title" *ngIf="isPaidAddonEnabled">
          <p class="addons-title" *ngIf="availableAddons.length > 0">{{'ENTITY.OFFER-EXTRAS.ADDONS.TITLE' | translate}}</p>
          <div class="addons-box" *ngIf="availableAddons && selectedAddons">
              <sb-addons-select
                [selectedAddons]="selectedAddons"
                [availableAddons]="availableAddons"
                [formGroup]="addonsFormGroup"
                [adobeDamUrl]="getAdobeDamUrl()"
                [incompatibilities]="incompatibilities"
                (addonsToggle)="onAddonsToggle($event)"></sb-addons-select>
          </div>
        </div>
        <!-- endregion -->

        <!-- <sb-promo-banner></sb-promo-banner> -->

        <!-- MGM -->
        <div class="promo-code-box-container sb-form-block__title" *ngIf="!!shouldShowMGMBlock || !!shouldShowCouponBlock">
          <div class="promo-code-box">
            <sb-insert-promo-code-block (modalOpen)="openMgmModal()" [shouldShowBlock]="!!shouldShowMGMBlock" [hasCode]="!!mgmCode" [promoType]="'MGM'" [promoSubtype]="mgmCodeActivationMethod"></sb-insert-promo-code-block>
          </div>
          <div class="promo-code-box">
            <sb-insert-promo-code-block (modalOpen)="openCouponModal()" [shouldShowBlock]="!!shouldShowCouponBlock" [code]="couponCode" [hasCode]="!!couponCode" [promoType]="'COUPON'"></sb-insert-promo-code-block>
          </div>
        </div>
        <!-- MGM -->
      </div>
    </div>
    <!-- endregion -->

    <!-- region Buttons -->
    <section class="sb-step__form__footer offer-extras">
      <sb-navigation-buttons [isSticky]="shouldBeSticky" (backClick)="goToPreviousStep()" (submitClick)="goToNextStep()"></sb-navigation-buttons>
    </section>
    <!-- endregion -->
  </form>
</div>
